<!-- eslint-disable -->
<template>
  <v-container fluid class="caso-component">
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">LISTA DE VEHÍCULOS</h4>
    </v-flex>

    <v-tabs v-model="activeTab" background-color="transparent" color="primary">
      <v-tab>Vehículos</v-tab>
      <v-tab>Inmovilizados</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <!-- Tab 0: lista existente (sin cambios internos) -->
      <v-tab-item>
        <v-card>
          <v-card-text>
            <filtros
              ref="criterios"
              :campos.sync="camposfiltros"
              @actualizarFiltro="getData"
              @nuevo="addUpdate"
            ></filtros>
          </v-card-text>
        </v-card>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :options.sync="options"
          :loading="loading"
          class="elevation-1"
          no-data-text="Datos no disponibles"
          no-results-text="Cargando..."
          :dense="true"
          fixed-header
          :height="500"
          :footer-props="{
            'show-current-page': false,
            'show-first-last-page': false,
            'items-per-page-options': [],
            'items-per-page-text': '',
          }"
          :disable-sort="true"
        >
          <template v-slot:top>
            <v-toolbar flat></v-toolbar>
          </template>
          <template v-slot:footer.page-text>
            <v-row justify="end" align="center" class="ma-0 pa-0">
              <v-col class="col-content-footer">
                <v-btn
                  type="button"
                  :loading="loading"
                  :disabled="paginas.length === 0"
                  @click="getDataAnterior"
                  class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                  aria-label="Previous page"
                >
                  <span class="v-btn__content">
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--light"></i>
                  </span>
                </v-btn>
                <v-btn
                  type="button"
                  :loading="loading"
                  :disabled="!ultimoDocumento"
                  @click="getDataSiguiente"
                  class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                  aria-label="Next page"
                >
                  <span class="v-btn__content">
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--light"></i>
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip
              small
              :color="item.estado ? 'success' : 'secondary'"
              dark
              v-text="item.estado ? 'Activo' : 'Inactivo'"
            ></v-chip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-4" title="Editar" @click="addUpdate(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="inavilitar(item)" title="Inactivar">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
        <modal-add
          v-if="showModal"
          :showModal.sync="showModal"
          :id="id"
          @actualizar="getData"
        ></modal-add>
      </v-tab-item>

      <!-- Tab 1: vehículos inmovilizados -->
      <v-tab-item>
        <vehiculos-inmovilizados />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import { db } from "../../firebase";
import moment from "moment";
import ModalAdd from "./ModalAdd.vue";
import Filtros from "../General/Filtros.vue";
import VehiculosInmovilizados from "./VehiculosInmovilizados.vue";
import debounce from "lodash/debounce";

export default {
  components: {
    ModalAdd,
    Filtros,
    VehiculosInmovilizados,
  },
  name: "Vehiculos",
  data() {
    return {
      activeTab: 0,
      coleccion: "vehiculos",
      totalItems: 0,
      lastVisible: null,
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        { text: "PLACA", value: "placa" },
        { text: "CARROCERIA", value: "carroceria" },
        { text: "CLASE", value: "clase" },
        { text: "LINEA", value: "linea" },
        { text: "MARCA", value: "marca" },
        { text: "MODELO", value: "modelo" },
        { text: "POLIZA", value: "poliza" },
        { text: "SERVICIO", value: "servicio" },
        { text: "CLIENTE", value: "nombreCliente" },
        { text: "CREADO", value: "creado" },
        { text: "ESTADO", value: "estado" },
        { text: "ACCIONES", value: "action" },
      ],
      clientes: [],
      ultimoDocumento: null,
      primerDocumento: null,
      unsubscribe: null,
      camposNumericos: [],
      querySnapshot: [],
      paginas: [],
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    user() {
      return this.$store.getters.user;
    },
    autorizaCrear() {
      return [
        "Call Center",
        "Coordinador Contact Center",
        "Administrador",
      ].includes(this.logueado.cargo);
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value !== "estado" && element.value !== "action") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
    // this.getClientes();
    await this.getData();
  },
  watch: {
    options: {
      handler: async function () {
        await this.filtros();
      },
      deep: true,
    },
  },
  methods: {
    async filtros() {
      const { sortBy, sortDesc } = this.options;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
      this.criterios = await this.$refs?.criterios?.enviarCriterios();

      if (this.criterios?.length > 0 && this.criterios[0]?.valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element?.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            this.valorFiltro = element?.valor;
          }
        });
      }
    },
    async getData() {
      try {
        await this.filtros();
        this.loading = true;
        let consulta = db.collection(this.coleccion).where("placa", "!=", "");

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.camposNumericos.includes(this.campoFiltro)
              ? parseInt(this.valorFiltro || 0)
              : this.valorFiltro?.toUpperCase().trim()
          );
        }

        if (!this.criterios[0]?.valor) {
          // consulta = consulta.orderBy(this.ordenar || "placa", this.typoOrdenar || "desc")
          consulta = consulta.orderBy("placa", "asc");
        }
        consulta = consulta.limit(10);
        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          this.querySnapshot = querySnapshot;
          this.procesarQuerySnapshot();
        });
      } catch (error) {
        console.log("error", error);
        this.handleError(error);
      }
    },
    async getDataSiguiente() {
      if (!this.ultimoDocumento) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db.collection(this.coleccion).where("placa", "!=", "");

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy(
            this.ordenar || "placa",
            this.typoOrdenar ? "desc" : "asc"
          );
        }

        consulta = consulta.limit(10).startAfter(this.ultimoDocumento);

        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.paginas.push(this.primerDocumento);
            this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos siguientes:", error);
        this.handleError(error);
      }
    },
    async getDataAnterior() {
      if (this.paginas.length === 0) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db.collection(this.coleccion).where("placa", "!=", "");

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy(
            this.ordenar || "placa",
            this.typoOrdenar ? "desc" : "asc"
          );
        }

        const documentoAnterior = this.paginas.pop();
        consulta = consulta.limit(10).startAt(documentoAnterior);

        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos anteriores:", error);
        this.handleError(error);
      }
    },
    async procesarQuerySnapshot() {
      const datos = await Promise.all(
        this.querySnapshot.docs.map( async (doc) => {
          const nameCliente = doc.data().uidcliente && (await this.obtenerCliente(doc.data().uidcliente, "clientes"));
          return {
            id: doc.id,
            ...doc.data(),
            poliza:
              doc.data().poliza && typeof doc.data().poliza === "string"
                ? doc.data().poliza
                : typeof doc.data().poliza === "object"
                ? doc.data().poliza.nombre_producto
                : Array.isArray(doc.data().poliza)
                ? doc.data().poliza[0].nombre_producto
                : "SIN POLIZA" || "SIN POLIZA",
            nombreCliente: nameCliente
              ? `${nameCliente.nombres} ${nameCliente.apellidos} ${nameCliente.identificacion}`
              : ""
          }
        })
      )
      this.desserts = datos;
      this.ultimoDocumento =
        this.querySnapshot.docs[this.querySnapshot.docs.length - 1];
      this.primerDocumento = this.querySnapshot.docs[0];
      this.loading = false;
    },
    async obtenerCliente(id, tabla) {
      const registro = await db.collection(tabla).doc(id).get();
      if (registro.empty) {
        return {};
      }
      return registro.data();
    },
    addUpdate(item = {}) {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id || null;
      this.showModal = true;
    },
    inavilitar(item) {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.$swal({
        title: "Confirmación",
        text: "¿Está seguro de inactivar este registro?",
        icon: "warning",
        confirmButtonText: "Sí, Inactivar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          db.collection(this.coleccion).doc(item.id).update({ estado: false });
          await this.getData();
        }
      });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Error", text: message });
      this.loading = false;
    },
    getClientes() {
      db.collection("clientes").onSnapshot((snapshot) => {
        this.clientes = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      });
    },
  },
};
</script>

<style scoped>
/* Estilos personalizados */
</style>
